import { objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

import type { PostAppGroupIdLiquidValidationCheckSyntaxResult } from "./types";

export const isPostAppGroupIdLiquidValidationCheckSyntaxResult =
  objectOf<PostAppGroupIdLiquidValidationCheckSyntaxResult>({
    valid: boolean,
    errors: string,
  });
